function Instructions({ children }) {
    return <div className="mb-4 text-sm">{children}</div>
  }
  
  export default Instructions
  